// components/GoogleAd.js
// components/GoogleAd.js
import React, { useEffect, useRef, useState } from "react";

const GoogleAd = ({ client, slot }) => {
  const adRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    try {
      if (window.adsbygoogle && adRef.current) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
        setTimeout(() => {
          // Check if ad iframe is present (means ad was served)
          const iframe = adRef.current.querySelector("iframe");
          if (iframe) {
            setLoaded(true);
          }
        }, 1000); // give time for ad to render
      }
    } catch (e) {
      console.error("Adsbygoogle error:", e);
    }
  }, []);

  if (!loaded) return null; // 🔥 Nothing is rendered if ad didn't load

  return (
    <div ref={adRef}>
      <ins
        className="adsbygoogle"
        style={{ display: "block" }}
        data-ad-client="ca-pub-3865115238408987"
        data-ad-slot="1234567890"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default GoogleAd;

// import React, { useEffect } from "react";

// const GoogleAd = ({ slot }) => {
//   useEffect(() => {
//     try {
//       (window.adsbygoogle = window.adsbygoogle || []).push({});
//     } catch (e) {
//       console.error("Ad error", e);
//     }
//   }, []);

//   return (
//     <ins className="adsbygoogle"
//          style={{ display: "block" }}
//          data-ad-client="ca-pub-3865115238408987"  // <-- Replace with your AdSense client ID
//          data-ad-slot="1234567890"                      // <-- Slot ID for this specific ad
//          data-ad-format="auto"
//          data-full-width-responsive="true"></ins>
//   );
// };

// export default GoogleAd;
